<template>
  <div>
    <div class="service-list">
      <ul>
        <li v-for="platform in platformList" :key="platform.platformAbbreviation">
          <div class="bg">
            <img :src="platform.platformImageUrl" />
          </div>
          <div class="cover">
            <div class="text">
              <p class="name">{{ platform.platformName }}</p>
              <p class="code">{{ platform.platformAbbreviation }}</p>
            </div>
          </div>
          <div class="checkbox-container">
            <Checkbox
              :disabled="!platform.enable"
              :onChange="handleServiceChecked(platform)"
              :checked="platform.checked"
            />
          </div>
        </li>
      </ul>
    </div>
    <h3 class="title">
      请选择角色
      <span class="required-symbol">*</span>
    </h3>
    <div class="choose-role-area">
      <div v-for="platform in selectedPlatformList" :key="platform.platformAbbreviation">
        <span class="form-item-label">{{ platform.platformName }}:</span>
        <span style="display: inline-block; width: 750px;">
          <template v-for="identity in platform.identity">
            <Checkbox
              v-if="identity.code !== 'fin_institution'"
              :key="identity.code"
              style="margin-left: 25px;"
              :label="identity.name"
              :onChange="handleIdentityChecked(identity)"
              :checked="identity.checked"
              :disabled="identity.disabled"
            >
              <span v-if="identity.statusText">{{ '(' + identity.statusText + ')' }}</span>
            </Checkbox>
          </template>
        </span>
      </div>
    </div>
    <div class="foot-area">
      <span class="next">
        <Button
          :text="!hasOpenedOrOpenningServices || hasSelectOtherServices ? '完善资质信息' : '查看资质信息'"
          type="danger"
          :onClick="submit"
        />
      </span>
    </div>
  </div>
</template>
<script>
  import api from '@/api';

  import Steps from '@/components/Steps/index.vue';
  import PageHead from '@/components/PageHead/index.vue';
  import Checkbox from '@/components/Checkbox/index.vue';
  import Button from '@/components/Button/index.vue';
  import Message from '@/components/Message';

  import {
    routes,
    openningAndOpenedStatus,
    certificationStatusCode,
    platformCode,
  } from '@/config';
  import { validIsSupplier, validIsPurchaser } from '@/utils';

  export default {
    name: 'choose-service-company',
    data() {
      return {
        platformCode: this.$route.query.platform_code,
        platformList: [],
        hasAdditionalCert: false,
        tradePlatform: null,
        cenpurPlatform: null,
        logisticsPlatform: null,
        finPlatform: null,
        wmsPlatform: null,
        shipperIdentity: null,
        finAgency: null, // 借代采商
        finBorrower: null, // 借款人

        supplyCategoryTree: [], // 供应品类树
        purchaseCategoryTree: [], // 采购品类树
        hasSupplier: false,
        hasPurchaser: false,
        supplyDefaultCheckedKeys: [],
        purchaseDefaultCheckedKeys: [],
        supplierHasOpend: false,
        purchaserHasOpend: false,
        openedPlatformList: [],
        hasCert: false,
      };
    },
    methods: {
      /**
       * 获取平台列表
       */
      getPlatformList() {
        return api.getPlatformListByCertType(1).then(res => {
          if (res.code === 0) {
            this.platformList = this.platformList.concat(res.data).sort((a, b) => {
              return a.order - b.order;
            });
            this.platformList.forEach(platform => {
              switch (platform.platformCode) {
                case platformCode.trade:
                  this.tradePlatform = platform;
                  break;
                case platformCode.cenpur:
                  this.cenpurPlatform = platform;
                  break;
                case platformCode.logistics:
                  this.logisticsPlatform = platform;
                  break;
                case platformCode.fin:
                  this.finPlatform = platform;
                  break;
                case platformCode.wms:
                  this.wmsPlatform = platform;
                  break;
                default:
                  break;
              }
            });
            this.logisticsPlatform.identity.forEach(identity => {
              if (identity.code === 'logistics_shipper') {
                this.shipperIdentity = identity;
              }
            });
            this.finPlatform.identity.forEach(identity => {
              if (identity.code === 'fin_agency') {
                this.finAgency = identity;
              }
              if (identity.code === 'fin_borrower') {
                this.finBorrower = identity;
              }
            });
          }
          return res;
        });
      },
      checkQueryPlatform() {
        this.platformList.forEach(platform => {
          if (platform.platformCode === this.$route.query.platform_code) {
            this.$set(platform, 'checked', true);
            this.$set(platform, 'checkByUser', true);
          }
        });
      },
      /**
       * 获取已经拥有的服务信息
       */
      getServiceInfo() {
        return api.getServiceInfo().then(res => {
          if (res.code === 0) {
            let openedPlatformList = (this.openedPlatformList = res.data);
            this.platformList.forEach(platform => {
              if (platform.platformCode === this.$route.query.platform_code) {
                this.$set(platform, 'checked', true);
              }
            });
            this.platformList.forEach(platformO => {
              // 是否开通了代采商身份
              let hasFinAgency = openedPlatformList.filter(platform => {
                return !!platform.identity.filter(identity => {
                  return (
                    identity.code === 'fin_agency' &&
                    identity.status !== certificationStatusCode.reject
                  );
                }).length;
              }).length;

              // 是否开通了集采供应商身份
              this.hasSupplier = openedPlatformList.filter(platform => {
                return !!platform.identity.filter(identity => {
                  const isSupplier = validIsSupplier(identity.code);
                  if (
                    isSupplier &&
                    openningAndOpenedStatus.indexOf(identity.status) !== -1
                  ) {
                    this.supplierHasOpend = true;
                  }
                  return (
                    isSupplier &&
                    identity.status !== certificationStatusCode.reject
                  );
                }).length;
              }).length;

              // 是否开通了集采采购商身份
              this.hasPurchaser = !!openedPlatformList.filter(platform => {
                return !!platform.identity.filter(identity => {
                  const isPurchaser = validIsPurchaser(identity.code);
                  if (
                    isPurchaser &&
                    openningAndOpenedStatus.indexOf(identity.status) !== -1
                  ) {
                    this.purchaserHasOpend = true;
                  }
                  return (
                    isPurchaser &&
                    identity.status !== certificationStatusCode.reject
                  );
                }).length;
              }).length;

              // 是否开通了借款人
              let hasBorrower = !!openedPlatformList.filter(platform => {
                return !!platform.identity.filter(identity => {
                  return (
                    identity.code === 'fin_borrower' &&
                    identity.status !== certificationStatusCode.reject
                  );
                }).length;
              }).length;
              const allIdentity = platformO.identity.map(el => el.code);
              // 将已开通的服务及身份勾选
              openedPlatformList.forEach(platformI => {
                if (platformO.platformCode === platformI.platformCode) {
                  // 必须要有一个申请过的身份，才默认勾选上，并且不可取消
                  const hasAppliedIdentity = !!platformI.identity.find(el => el.status && allIdentity.includes(el.code));
                  this.$set(platformO, 'checked', hasAppliedIdentity);
                  this.$set(platformO, 'applied', hasAppliedIdentity);
                  this.$set(platformO, 'enable', !hasAppliedIdentity);
                  platformO.identity.forEach(identityO => {
                    platformI.identity.forEach(identityI => {
                      if (identityO.code === identityI.code) {
                        this.$set(
                          identityO,
                          'checked',
                          identityI.status !== certificationStatusCode.reject
                        );
                        this.$set(
                          identityO,
                          'applied',
                          identityI.status !== certificationStatusCode.reject
                        );
                        this.$set(identityO, 'status', identityI.status);
                        this.$set(identityO, 'statusText', identityI.statusText);
                        this.$set(
                          identityO,
                          'disabled',
                          openningAndOpenedStatus.indexOf(identityI.status) !== -1
                        );
                      }
                      // 开通了代采商，则不能开通借款人
                      if (identityO.code === 'fin_borrower' && hasFinAgency) {
                        this.$set(identityO, 'disabled', true);
                      }

                      // 开通了借款人，则不能开通代采商
                      if (identityO.code === 'fin_agency' && hasBorrower) {
                        this.$set(identityO, 'disabled', true);
                      }
                    });
                  });
                }
              });
            });
          }
        });
      },
      handleServiceChecked(platform) {
        let self = this;
        return function servicesChecked(checked) {
          self.$set(platform, 'checked', checked);
          if (!checked) {
            // self.$set(platform, 'uncheckedByUser', true)
            platform.identity.forEach(identity => {
              self.$set(identity, 'checked', false);
            });
            if (platform.platformCode === platformCode.cenpur || platform.platformCode === platformCode.bid) {
              self.hasSupplier = false;
              self.hasPurchaser = false;
            }
          }
        };
      },
      handleIdentityChecked(identity) {
        let self = this;
        return function identityChecked(checked) {
          self.$set(identity, 'checked', checked);
          if (checked) {
            // 借款人和代采商只能选择其一
            if (identity.code === 'fin_agency' && self.finBorrower) {
              self.$set(self.finBorrower, 'checked', false);
            }
            if (identity.code === 'fin_borrower' && self.finAgency) {
              self.$set(self.finAgency, 'checked', false);
            }
            if (validIsSupplier(identity.code)) {
              self.hasSupplier = true;
            }
            if (validIsPurchaser(identity.code)) {
              self.hasPurchaser = true;
            }
          } else {
            if (validIsSupplier(identity.code)) {
              self.hasSupplier = false;
            }
            if (validIsPurchaser(identity.code)) {
              self.hasPurchaser = false;
            }
          }
        };
      },
      validate() {
        if (!this.selectedPlatformList.length) {
          Message.error('请选择您要开通的平台');
          return false;
        }

        if (
          !this.hasOpenedOrOpenningServices &&
          !this.selectedIdentityList.length
        ) {
          Message.error('请选择你要开通的平台角色');
          return false;
        }

        return true;
      },
      submit() {
        if (!this.validate()) {
          return;
        }

        if (
          !this.validSelectedPlatformList.length ||
          !this.selectedIdentityList.length
        ) {
          this.$router.push({
            path: routes.viewCertification,
          });
          return;
        }
        if (!this.hasAppliedPlatformList) {
          this.$router.push({
            path: routes.createCertification,
            query: {
              ...this.$route.query,
              platformList: this.validSelectedPlatformList
                .map(platform => platform.platformCode)
                .join(','),
              identityList: this.selectedIdentityList.join(','),
            },
          });
          return;
        }

        this.$router.push({
          path: routes.certification,
          query: {
            ...this.$route.query,
            platformList: this.validSelectedPlatformList
              .map(platform => platform.platformCode)
              .join(','),
            identityList: this.selectedIdentityList.join(','),
          },
        });
      },
    },
    mounted() {
      this.getPlatformList().then(res => {
        if (res.code === 0) {
          this.checkQueryPlatform();
          this.getServiceInfo();
        }
      });
    },
    computed: {
      /**
       * 是否有已经开通或者正在审核过程中的服务
       */
      hasOpenedOrOpenningServices() {
        // 只要有一个平台当中的一个角色是处于开通或者开通中
        return this.openedPlatformList.some(platform => {
          return platform.identity.some(i => {
            return openningAndOpenedStatus.includes(i.status);
          });
        });
      },
      // 是否有申请过的身份资质信息
      hasAppliedPlatformList() {
        return this.openedPlatformList.some(opendPlatform => {
          return this.platformList.some(platform => {
            return opendPlatform.identity.some(opendIdentity => {
              return platform.identity.some(identity => {
                return identity.code === opendIdentity.code
              });
            })
          });
        })
      },
      selectedPlatformList() {
        return this.platformList.filter(platform => platform.checked);
      },
      /**
       * 至少勾选了一个有效的角色，才算是勾选了对应的平台，否则不传
       */
      validSelectedPlatformList() {
        return this.selectedPlatformList.filter(platform => {
          return platform.identity.some(i => {
            return openningAndOpenedStatus.indexOf(i.status) === -1 && i.checked;
          });
        });
      },
      selectedIdentityList() {
        return this.validSelectedPlatformList.reduce((preValue, el) => {
          const identityList = el.identity
            .filter(i => {
              return (
                openningAndOpenedStatus.indexOf(i.status) === -1 && i.checked
              );
            })
            .map(el => el.code);
          return preValue.concat(identityList);
        }, []);
      },
      /**
       * 是否有勾选未申请的服务
       */
      hasSelectOtherServices() {
        return this.selectedPlatformList.some(platform => {
          return platform.identity.some(i => {
            return !i.applied && i.checked;
          });
        });
      },
    },
    watch: {
      filterCategoryText(v) {
        this.$refs.categoryTree.filter(v);
      },
    },
    components: { Steps, Checkbox, Button, PageHead },
  };
</script>
<style lang="scss" scoped>
  @import '../style.scss';
</style>
